import { Blur, Remote } from "@/api/loaderRemote";
import Image from "next/image";
import React from "react";
import HeaderSliderButton from "./HeaderSliderButton";

const HeaderSlider = ({ sliderCaption }) => {
  const { filename } = sliderCaption?.[0] || {};
  return (
    <div className="xl:container lg:relative  sm:after:content  sm:before:absolute before:left-0 sm:before:w-[424px] before:top-[167px] before:h-[424px] before:rounded-full before:bg-elippseColor before:filter before:blur-custom   lg:mb-7  after:content after:absolute after:right-0 sm:after:w-[424px] after:top-[127px] after:h-[424px] after:rounded-full after:bg-elippseColor after:filter after:blur-custom">
      <div className="flex overflow-hidden lg:rounded-[36px] lg:relative after:content after:absolute after:left-0 after:bottom-0 after:w-full lg:after:h-[350px] after:h-full lg:after:rounded-[36px] after:bg-headerGradient">
        <Image
          src={filename ? `${filename}?l=0` : "/headerSlider.jpeg"}
          loader={filename ? Remote : undefined}
          blurDataURL={filename ? Blur(filename) : undefined}
          width={1920}
          height={442}
          priority
          alt="banner"
          sizes="50vw"
          className="lg:h-[442px] h-full object-cover lg:relative absolute top-0 left-0 aspect-[3/1]"
        />
        <HeaderSliderButton />
      </div>
    </div>
  );
};

export default HeaderSlider;
